import { IntlClass } from '@fx-ui/intl';

export const Intl = new IntlClass();
